import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Descarga Instantánea', 'Sin Suscripción', 'Acceso de por Vida', 'Garantía de 7 Días'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-stone-50 px-4 pb-16 pt-4 sm:px-5 sm:pb-20 sm:pt-5" data-id="element-111" data-mp="4lql31pohn65">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="4jvx1ej41exu">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="font-serif text-[1.85rem] font-black leading-[1.05] tracking-tight text-stone-900 sm:text-6xl md:text-7xl" data-id="element-113" data-mp="128607wumu8qj">
          Resuelve un Año Entero de Clases de Inglés en Solo{' '}
          <span className="italic text-red-600" data-id="element-114" data-mp="3d1im5e7m7kpj">5 Minutos</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-stone-600 sm:mt-5 sm:text-lg" data-id="element-115" data-mp="3cz5u28857tyr">
          Únete a +1.500 docentes que dejaron de improvisar. Entra a cada clase
          con materiales, actividades, evaluaciones y recursos listos para
          enseñar, practicar e inspirar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} className="-mx-2 mt-3 pb-3 sm:mx-auto sm:mt-8 sm:max-w-3xl sm:pb-5 sm:pt-2.5" data-id="element-116" data-mp="3ebisosz2rm5p">
          <img src="https://cdn.magicpatterns.com/uploads/tDsyECN75Unvw2WENiC6ty/5077c8fc-cde3-49f9-a594-b81796ebe627.webp" alt="Pack INGLÉS LISTO™: los 12 volúmenes y los 5 bonos, en computadora, tablet y móvil" className="w-full" data-id="element-117" data-mp="2ql692kugw0za" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="sm:mt-8" data-id="element-118" data-mp="2ljh0dbupvzed">
          <CtaButton href="#offer" data-id="element-119" data-mp="n9qira2x6u7y" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-stone-500 sm:text-sm" data-id="element-120" data-mp="ic86b9pp1wv7">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-121" data-mp="dbapp1kc1avt" data-mpi={index}>
                <span data-id="element-122" data-mp="1azkqjd8dtslc">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-stone-300" data-id="element-123" data-mp="162ubmt8bd31i">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}